<template>
  <div class="audclcont between">
    <div class="cont">
      <div class="header between">
        <div class="audcl_title flex_start">
          <div
            v-for="(item, index) in taglist"
            :key="index"
            :class="{ actitle: isactitle == index }"
            @click="clitag(index)"
          >
            {{ item.name }}
          </div>
        </div>
        <!-- <div class="audclmo">更多></div> -->
      </div>
      <div class="audclist">
        <div
          class="audclitem"
          v-for="(item, index) in audiolist"
          :key="index"
          :class="{ bodernone: audiolist.length - 1 == index }"
          @click="tojump(item)"
        >
          <div class="problem ellipsis">{{ item.title }}</div>
          <div class="answer">
            {{ item.content | toEllipsisFilter(130) }}
          </div>
          <div class="simple between">
            <div class="audioyp between">
              <div class="flex_start">
                <div class="cover">
                  <img :src="item.avatar" class="img1" />
                  <div class="bf center" v-if="index % 2 == 0">
                    <img src="../../../assets/laws/bf.png" />
                  </div>
                  <div class="bf zt center" v-else>
                    <img src="../../../assets/claim/zt.png" />
                  </div>
                </div>
                <div>{{ item.true_name }}律师</div>
              </div>
              <div>{{ item.duration }}</div>
            </div>

            <div class="ritext flex_end">
              <div class="center">
                <img src="../../../assets/claim/time.png" class="time" />
                {{ item.updated_at || "2021-04-05" }}
              </div>
              <div class="center">
                <img src="../../../assets/base/kan.png" alt="num" />
                {{ item.view_num }}人听过
              </div>
            </div>
          </div>
        </div>

        <div class="pagination mt20">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-count="pageCount"
            :current-page="currentPage"
            :pager-count="5"
            @current-change="turnpage"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="sideadv">
      <videolist class="vrk" :num="4" title="语音问答排行榜" />
      <articlelist
        class="arclerk"
        @Inabatch="Inabatch"
        :list="gztllist"
        title="精选解答推荐"
      />
      <videolist2 class="vlrecom" :list="tjvideolist" title="视频推荐" />
    </div>
  </div>
</template>

<script>
import videolist from "../../videoclaim/componens/videolist";
import videolist2 from "../../videoclaim/componens/videolist_2";
import articlelist from "../../videoclaim/componens/articlelist";
import audiolist from "../../videoclaim/componens/audiolist";

export default {
  components: {
    videolist,
    videolist2,
    articlelist,
    audiolist,
  },
  data: () => ({
    taglist: [],
    isactitle: 0,
    currentPage: 1, //当前
    pageCount: 17, //总页数
    total: 17, //总条目
    audiolist: [],
    gztllist: [],
    jdpage: 1,
    tjvideolist: [],
  }),
  beforeMount() {
    this.getproblem();
    this.getgztl();
    this.getvideo()
  },
  methods: {
    turnpage(e) {
      this.currentPage = e;
      this.getaudiolist();
    },
    clitag(index) {
      this.isactitle = index;
      this.currentPage = 1;
      this.getaudiolist();
    },
    getproblem() {
      this.$http.fdlaw.getIndustryIfy().then((res) => {
        this.taglist = res.data;
        this.getaudiolist();
      });
    },
    getaudiolist() {
      let data = {
        limit: 8,
        cat_id: this.taglist[this.isactitle].id,
        page: this.currentPage,
      };
      this.$http.laws.getaudiolist(data).then((res) => {
        this.total = res.data.total;
        this.pageCount = res.data.last_page;
        this.audiolist = res.data.data;
      });
    },
    tojump(item) {
      this.$router.push({
        path: "/laws/audioimdet",
        query: {
          audioinId: item.id,
        },
      });
    },
    getgztl() {
      let data = {
        limit: 3,
        page: this.jdpage,
        order: "hot",
      };
      this.$http.laws.getarticlist(data).then((res) => {
        this.gztllist = res.data.data;
      });
    },
    Inabatch() {
      this.jdpage++;
      this.getgztl();
    },
    getvideo() {
      let data = {
        limit: 3,
        page: 1,
        order: "hot",
      };
      this.$http.laws.getvideolist(data).then((res) => {
        console.log(res.data);
        this.tjvideolist = res.data.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.audclcont {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  align-items: flex-start;
  .cont {
    width: 856px;
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    .header {
      width: 100%;
      border-bottom: 1px solid #eeeeee;
      .audcl_title {
        height: 57px;
        div {
          cursor: pointer;
          margin-left: 40px;

          font-size: 18px;
          color: #333333;
        }
        .actitle {
          color: #0465ea;
          position: relative;
          &::after {
            position: absolute;
            content: "";
            bottom: -18px;
            left: 50%;
            transform: translateX(-50%);
            width: 58px;
            height: 4px;
            background: #0465ea;
          }
        }
      }
      .audclmo {
        font-size: 16px;
        color: #666666;
        margin-right: 22px;
      }
    }
    .audclist {
      padding-bottom: 30px;
      .audclitem {
        cursor: pointer;
        padding: 25px 34px;
        border-bottom: 1px solid #eee;
        .problem {
          font-size: 16px;
          color: #333333;
          line-height: 20px;
        }
        .answer {
          margin: 12px 0;
          font-size: 12px;
          color: #666666;
          line-height: 24px;
        }
        .simple {
          .audioyp {
            width: 280px;
            height: 50px;
            padding: 0 12px;
            background: #f8f8f8;
            border-radius: 5px;
            font-size: 16px;
            color: #666666;
            .cover {
              position: relative;
              width: 40px;
              height: 40px;
              border-radius: 50%;
              overflow: hidden;
              margin-right: 10px;
              .img1 {
                width: 100%;
                height: 100%;
                margin-right: 10px;
              }
              .bf {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.2);
                img {
                  width: 12px;
                  height: 12px;
                }
              }
              .zt {
                background-color: rgba(0, 0, 0, 0.4);
                img {
                  width: 15px;
                  height: 16px;
                }
              }
            }
          }

          .ritext {
            font-size: 12px;
            color: #999999;
            img {
              margin-right: 8px;
            }
            div {
              margin-left: 48px;
            }
            .time {
              width: 12px;
              height: 12px;
            }
            .num {
              width: 15px;
              height: 12px;
            }
          }
        }
        &:hover {
          .problem {
            color: #0465ea;
          }
        }
        &:last-child {
          border-bottom: none;
        }
      }
      .bodernone {
        border: none;
      }

      .pagination {
        text-align: center;
        ::v-deep .el-pagination.is-background .btn-next,
        ::v-deep .el-pagination.is-background .btn-prev,
        ::v-deep .el-pagination button,
        ::v-deep .el-pagination span:not([class*="suffix"]),
        ::v-deep .el-pagination.is-background .el-pager li {
          min-width: 36px;
          height: 36px;
          line-height: 36px;
        }
        ::v-deep
          .el-pagination.is-background
          .el-pager
          li:not(.disabled).active,
        ::v-deep
          .el-pagination.is-background
          .el-pager
          li:not(.disabled):hover {
          color: #ffffff !important;
          background: #0057ff !important;
        }
      }
    }
  }
  .sideadv {
    width: 314px;
    .vrk {
      width: 314px;
      height: 490px;
    }
    .arclerk {
      margin-top: 30px;
      width: 314px;
      height: 412px;
    }
    .vlrecom {
      margin-top: 30px;
      width: 314px;
      height: 640px;
    }
  }
}
</style>